import { TypeOptions, toast } from 'react-toastify'

type Options = {
  autoClose?: number | false
}

export const notify = (
  message: string,
  type: TypeOptions,
  options: Options = {}
) => {
  toast(message, {
    position: 'top-center',
    autoClose:
      typeof options.autoClose !== 'undefined' ? options.autoClose : 3500,
    hideProgressBar: true,
    closeOnClick: true,
    draggable: false,
    type: type,
    theme: 'colored',
  })
}
